import { MD5 } from 'crypto-js';

export const USE_MOCK_SERVICE = process.env.REACT_APP_USE_MOCK_SERVICE;
export const REACT_APP_API_URL = process.env.REACT_APP_BASE_URL;
export const REACT_APP_SURVEY_ID = MD5(
  process.env.REACT_APP_SURVEY_ID
)?.toString();
export const REACT_APP_SURVEY_ID_ER = MD5(
  process.env.REACT_APP_SURVEY_ID_ER
)?.toString();
